import axiosInstance from "../axiosInstance";

export const generatedSalesCartService = {
  fetch: async (searchValue, limit = 15, skip = 0) => {
    try {
      let query = `/generated-sales-cart?$limit=${limit}&$skip=${skip}&$sort[createdAt]=-1`;
      query += `&$populate[0][path]=items.product`;

      if (searchValue) {
        query += `&$or[0][customer][$search]=${encodeURIComponent(searchValue)}`;
        query += `&$or[1][status][$search]=${encodeURIComponent(searchValue)}`;
        query += `&$or[2][items][sku][$search]=${encodeURIComponent(searchValue)}`;
      }

      const response = await axiosInstance.get(query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await axiosInstance.post("/generated-sales-cart", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (id, data) => {
    try {
      const response = await axiosInstance.patch(`/generated-sales-cart/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/generated-sales-cart/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
